const { TKTK = {} } = window;

/**
 * 開発用放送リスト
 * development mode のみ展開
 */
const liveList =
  process.env.NODE_ENV === 'development'
    ? [
        {
          liveThumb:
            'https://img.cdn.nimg.jp/s/nicolive/program-pictures/prod-program_template_KCTV/thumbnail_1549521181555.jpg/r640x360l.jpg?key=e5a0825745fecb98c5a54872ea7bdb0ee050b2af36d8f772c81efb561c131912',
          liveTitle: 'あいうえおあいうえおあいうえおあいうえおあいうえおあいうえおあいうえおあいうえお',
          liveDate: new Date(),
          liveUrl: '',
          channelId: 2644280,
          userImg: 'https://secure-dcdn.cdn.nimg.jp/nicoaccount/usericon/0/7488.jpg?1565888146',
          userName: 'るたんるたんるたんるたんるたんる',
        },
        {
          liveThumb:
            'https://img.cdn.nimg.jp/s/nicolive/program-pictures/prod-program_template_KCTV/thumbnail_1549521181555.jpg/r640x360l.jpg?key=e5a0825745fecb98c5a54872ea7bdb0ee050b2af36d8f772c81efb561c131912',
          liveTitle: 'あいうえお',
          liveDate: new Date(),
          liveUrl: '',
          channelId: 2644280,
          userImg: 'https://secure-dcdn.cdn.nimg.jp/nicoaccount/usericon/0/7488.jpg?1565888146',
          userName: 'るたん',
        },
      ]
    : [];

export const live = {
  namespaced: true,

  state: {
    /** 生放送リスト 取得はgetterを使う */
    liveList: [],
  },

  getters: {
    /** 生放送リスト */
    liveList(state) {
      return state.liveList.slice(0, 2);
    },

    /** 生放送が存在するかどうか */
    hasLiveList(state) {
      return state.liveList.length > 0;
    },
  },

  mutations: {
    /** stateに生放送リストをセット */
    setLiveList(state, liveList) {
      state.liveList = liveList;
    },
  },

  actions: {
    /** 生放送を取得するアクション */
    async getLive({ commit }) {
      commit('setLiveList', TKTK.liveList || liveList);
    },
  },
};
